import React, { useState, useEffect } from "react";
import LeftSideNavigation from "../../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { useHistory } from "react-router-dom";
import { BackLogoIconButton } from "../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { TopTextReusableComponent } from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import {
  ReusableOnboardingButton,
  ReusableOnboardingLink,
  ReusableOnboardingMapButton,
} from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
// import Switch from "react-switch";
// import { SuggestNewButton } from "../../../../../reusableOnboardingPopupComponent/suggestNew/SuggestNewButton";
import InputNumberFunc from "../../../../../../function/InputNumberFunc";
import {
  NewInputText,
  SelectBoxMUiInputComponent,
} from "../../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { FormControl, Select, InputLabel, MenuItem } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { ToggleButtonWithYesNo } from "../../../AllButton/ToggleButtonReuse";
import { useFormik } from "formik";
import * as yup from "yup";
import Alert from "react-s-alert";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { admin_update_new_subscription_for_vendor } from "../../../../../../store/actions/SuperAdminActions/adminNewVendorOnboard";
import { AmealioLoader } from "../../../../../Loader/AmealioLoader";
import { SliderReusableComponent } from "../../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import isEmpty from "../../../../../../store/validation/is-Empty";
import { MobileTopHeader } from "../../../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import Media from "react-media";

const validationSchema = yup.object({
  seat_capacity: yup
    .string()
    .required("seating capacity is required")
    .min(1, "minimum 1 digit")
    .max(5, "maximum 5 digit"),
  auto_pax: yup
    .string()
    .required("auto pax is required")
    .min(1, "minimum 1 digit")
    .max(5, "maximum 5 digit"),
  table_turn_around_time: yup.string().required("cut off time is required"),
});

export const GenralSeatingScreen = (props) => {
  let history = useHistory();

  const [disabled, setDisabled] = useState(props.location?.state?.access);

  const [state, setState] = useState({
    change_seating_area_screen: false,
    all_seating_area: [],
    seating_areas: [],
    casualGenralKidsAllowed: true,
    min_age: "",
    casualGenralHighChair: false,
    casualGenralHandicapAccess: false,
    casualGenralRoomNumber: false,
    casualGenralTableSeatManagement: false,
    name_of_software: "",
    seat_capacity: "",
    auto_pax: "",
    table_turn_around_time: 15,
    errors: {},
  });

  useEffect(() => {
    setState({
      ...state,
      all_seating_area: props?.seating_area && props?.seating_area,
    });
  }, [props?.seating_area]);

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  /*********************************************
   * @DESC - Seating Area Array Selector
   *********************************************/
  const onLocatedInsideArraySelector = (icon) => (e) => {
    e.preventDefault();
    let restaurantTypeArray = state.seating_areas;
    if (restaurantTypeArray.length === 0) {
      restaurantTypeArray.push(icon);
    } else {
      let isAlreadyPresent = restaurantTypeArray.includes(icon);
      if (isAlreadyPresent) {
        let indexOf = restaurantTypeArray.indexOf(icon);
        if (indexOf === 0 || indexOf) {
          restaurantTypeArray.splice(indexOf, 1);
        }
      } else {
        restaurantTypeArray.push(icon);
      }
    }
    setState({
      ...state,
      seating_areas: restaurantTypeArray,
    });
  };

  const genralSeatingScreenHandler = (type) => (e) => {
    if (type === "kidsAllowed") {
      setState({
        ...state,
        casualGenralKidsAllowed: !state.casualGenralKidsAllowed,
      });
    } else if (type === "highChair") {
      setState({
        ...state,
        casualGenralHighChair: !state.casualGenralHighChair,
      });
    } else if (type === "handicapAccess") {
      setState({
        ...state,
        casualGenralHandicapAccess: !state.casualGenralHandicapAccess,
      });
    } else if (type === "roomNumber") {
      setState({
        ...state,
        casualGenralRoomNumber: !state.casualGenralRoomNumber,
      });
    } else if (type === "tableSeat") {
      setState({
        ...state,
        casualGenralTableSeatManagement: !state.casualGenralTableSeatManagement,
      });
    } else if (type === "seatingArea") {
      setState({
        ...state,
        change_seating_area_screen: !state.change_seating_area_screen,
      });
    }
  };

  const insideSeatingGenralBackClick = (e) => {
    setState({
      ...state,
      change_seating_area_screen: !state.change_seating_area_screen,
    });
  };

  const formik = useFormik({
    initialValues: {
      min_age: "",
      name_of_software: "",
      seat_capacity: "",
      auto_pax: "",
      table_turn_around_time: 15,
    },
    validationSchema,

    onSubmit: (values) => {
      let valuesData = {
        // value:
        //   state.change_seating_area_screen === false &&
        //   state.seating_areas === false &&
        //   state.casualGenralKidsAllowed === false &&
        //   values.min_age === "" &&
        //   state.casualGenralHighChair === false &&
        //   state.casualGenralHandicapAccess === false &&
        //   state.casualGenralRoomNumber === false &&
        //   state.casualGenralTableSeatManagement === false &&
        //   values.name_of_software === "" &&
        //   values.seat_capacity === "" &&
        //   values.auto_pax === "" &&
        //   values.table_turn_around_time === ""
        //     ? false
        //     : true,
        // general_seating: {
        value:
          state.change_seating_area_screen === false &&
          state.seating_areas === false &&
          state.casualGenralKidsAllowed === true &&
          values.min_age === "" &&
          state.casualGenralHighChair === false &&
          state.casualGenralHandicapAccess === false &&
          state.casualGenralRoomNumber === false &&
          state.casualGenralTableSeatManagement === false &&
          values.name_of_software === "" &&
          values.seat_capacity === "" &&
          values.auto_pax === "" &&
          values.table_turn_around_time === ""
            ? false
            : true,
        seating_areas: state.seating_areas,
        kids_allowed: {
          value: state.casualGenralKidsAllowed,
          min_age: values.min_age,
        },
        highchair: state.casualGenralHighChair,
        handicap: state.casualGenralHandicapAccess,
        seating_on_request: state.casualGenralRoomNumber,
        seat_management: {
          value: state.casualGenralTableSeatManagement,
          name_of_software: values.name_of_software,
        },
        seat_capacity: values.seat_capacity,
        auto_pax: values.auto_pax,
        table_turn_around_time: values.table_turn_around_time,
        // },
      };
      const token = props?.auth?.user?.accessToken;
      const subscriptionId = props?.subscription?._id;
      let formData = props?.allSubscriptionsData;
      formData.casual_dining_status.seating.general_seating = valuesData;
      props.admin_update_new_subscription_for_vendor(
        subscriptionId,
        formData,
        token,
        onSuccess
      );
    },
  });

  const onSuccess = (e) => {
    Alert.success("<h4>General setting changes added successfully</h4>", {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    history.push("/admin-casual-dining/seatingmanagement");
  };

  const [count, setCount] = useState(1);
  const onClickSave = () => {
    setCount(count + 1);
    formik.handleSubmit();
  };

  useEffect(() => {
    if (formik.errors && formik.errors.seat_capacity) {
      let seat_capacityElement = document.getElementById("seat_capacity");
      seat_capacityElement.focus();
    } else if (formik.errors && formik.errors.auto_pax) {
      let auto_paxElement = document.getElementById("auto_pax");
      auto_paxElement.focus();
    } else if (formik.errors && formik.errors.table_turn_around_time) {
      let table_turn_around_timeElement = document.getElementById(
        "table_turn_around_time"
      );
      table_turn_around_timeElement.focus();
    }
  }, [count]);

  useEffect(() => {
    const generalSeating = {
      ...(props?.subscriptionData && props?.subscriptionData),
    };
    if (generalSeating?.kids_allowed && generalSeating?.kids_allowed?.min_age) {
      formik.setFieldValue(
        "min_age",
        generalSeating?.kids_allowed && generalSeating?.kids_allowed?.min_age
      );
    }
    if (
      generalSeating?.seat_management &&
      generalSeating?.seat_management?.name_of_software
    ) {
      formik.setFieldValue(
        "name_of_software",
        generalSeating?.seat_management &&
          generalSeating?.seat_management?.name_of_software
      );
    }
    if (generalSeating?.seat_capacity) {
      formik.setFieldValue("seat_capacity", generalSeating?.seat_capacity);
    }
    if (generalSeating?.auto_pax) {
      formik.setFieldValue("auto_pax", generalSeating?.auto_pax);
    }
    if (generalSeating?.table_turn_around_time) {
      formik.setFieldValue(
        "table_turn_around_time",
        generalSeating?.table_turn_around_time
      );
    }
    setState({
      ...state,
      all_seating_area: props?.seating_area && props?.seating_area,
      casualGenralHandicapAccess: !isEmpty(generalSeating?.handicap)
        ? generalSeating?.handicap
        : false,
      casualGenralHighChair: !isEmpty(generalSeating?.highchair)
        ? generalSeating?.highchair
        : false,
      casualGenralRoomNumber: !isEmpty(generalSeating?.seating_on_request)
        ? generalSeating?.seating_on_request
        : false,
      casualGenralKidsAllowed: !isEmpty(
        generalSeating?.kids_allowed && generalSeating?.kids_allowed?.value
      )
        ? generalSeating?.kids_allowed && generalSeating?.kids_allowed?.value
        : true,
      casualGenralTableSeatManagement: !isEmpty(
        generalSeating?.seat_management &&
          generalSeating?.seat_management?.value
      )
        ? generalSeating?.seat_management &&
          generalSeating?.seat_management?.value
        : false,
      seating_areas: !isEmpty(generalSeating?.seating_areas)
        ? generalSeating?.seating_areas
        : [],
    });
  }, [props?.subscriptionData]);

  if (props?.auth?.loader === true) {
    return (
      <React.Fragment>
        <AmealioLoader />
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={1} />
            </div>
            <div className="super-admin-right-side-panel">
              <HomeReusableTopBarNavigation />
              <div
                // id="onboarding-scrollbar"
                className="col-12 new-subscription-onboarding-component pt-4"
              >
                {/* <Media query="(min-width: 991px)">
                <div className="col-12">
                  <BackLogoIconButton
                    displayBackText={true}
                    displayArrow={true}
                    backButtonClicked={"/admin-casual-dining/seatingmanagement"}
                    notDisplaProgressBar={true}
                  />
                </div>
              </Media> */}
                <Media query="(max-width: 991px)">
                  <MobileTopHeader
                    link={true}
                    onLink={"/admin-casual-dining/seatingmanagement"}
                  />
                </Media>

                {state.change_seating_area_screen === false ? (
                  <div className="col-8 onboarding_process_screen-button-map inside-subscription-event-section">
                    <div>
                      <TopTextReusableComponent
                        headingText="Seating Information"
                        headingParagraph="Enter details about seating areas"
                      />
                      <div className="inside-event-offline-online-text mt-4 mb-4">
                        <h6 className="heading-seating-top ">
                          List your Seating area?
                        </h6>
                        <div className="f11-400 opacity">
                          Please include all the seating areas in your food
                          establishment facility. This will be provided as
                          options for the user while placing a request.
                        </div>
                      </div>
                      <div className="restaurant_type_onboarding_main">
                        <div
                          className={
                            state.all_seating_area.length > 8
                              ? "cuisine-main cuisine-main-padding-border"
                              : ""
                          }
                        >
                          <div
                            id="box-style"
                            className="cuisine-main-padding row"
                            // style={{
                            //   display: "flex",
                            //   flexWrap: "wrap",
                            //   justify: "space-between",
                            // }}
                          >
                            {state.all_seating_area.map((icon, index) => (
                              <ReusableOnboardingMapButton
                                key={index}
                                disabled={disabled}
                                classsection={
                                  state.seating_areas.some(
                                    (icons) =>
                                      // console.log(
                                      //   "icon ==>",
                                      //   icon._id,
                                      //   "icons ==>",
                                      //   icons
                                      // )
                                      icons === icon._id ||
                                      icons._id === icon._id
                                  )
                                    ? // state.seating_areas.includes(icon)
                                      "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_activesingle"
                                    : "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                                }
                                src={icon.icon}
                                title={icon.title}
                                onClick={onLocatedInsideArraySelector(icon)}
                              />
                            ))}
                          </div>
                          {/* <div className="suggest-button-heading">
                  <SuggestNewButton categoryId={"5f5723f455e36968b805b4cb"} />
                </div> */}
                        </div>
                      </div>
                    </div>
                    <div className="onboarding-map-setup-screen-autodetect-button ">
                      <ReusableOnboardingLink
                        buttonTitle="Back Button"
                        buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                        buttonText="Back"
                        link="/admin-casual-dining/seatingmanagement"
                      />
                      <ReusableOnboardingButton
                        buttonTitle="Next Button"
                        buttonClass={
                          state.seating_areas.length <= 0
                            ? "onboarding_button_link_reusable onboarding_button_link_reusable_gray ml-3"
                            : "onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                        }
                        disabled={
                          state.seating_areas.length <= 0 ? true : false
                        }
                        buttonText="Next"
                        buttonType="button"
                        onClick={
                          state.seating_areas.length <= 0
                            ? ""
                            : genralSeatingScreenHandler("seatingArea")
                        }
                      />
                    </div>
                  </div>
                ) : (
                  <div className="col-8 onboarding_process_screen-button-map inside-subscription-event-section">
                    <div>
                      <TopTextReusableComponent headingText="Seating General Settings" />
                    </div>
                    <div className="inside-event-offline-online-text">
                      <div className="row margin-between-toggler mt-4">
                        <div className="col-6 col-md-8 mb-4">
                          <h5
                            className="left-toggle-top-text-head"
                            style={{ fontSize: "0.85rem" }}
                          >
                            Kids Allowed?
                          </h5>
                          <div className="f12-700 opacity5">
                            (This may be relevant if you are a Bar and Night
                            Club)
                          </div>
                        </div>
                        {/* <div className="col-8">
                        <h4 className="left-toggle-top-text-head">
                          Kids Allowed?
                        </h4>
                      </div> */}
                        <div className="col-4 col-md-4">
                          <ToggleButtonWithYesNo
                            activeClass={state.casualGenralKidsAllowed}
                            checkedBox={state.casualGenralKidsAllowed}
                            disabled={disabled}
                            onChange={genralSeatingScreenHandler("kidsAllowed")}
                          />
                        </div>
                      </div>
                      <br />
                      {state.casualGenralKidsAllowed === true ? (
                        <div className="row margin-between-toggler">
                          <div className="col-6 col-md-8">
                            <h5
                              className="left-toggle-top-text-head"
                              style={{ fontSize: "0.85rem" }}
                            >
                              Min Age for Entry
                            </h5>
                          </div>
                          <div className="col-4 col-md-4">
                            <FormControl
                              variant="outlined"
                              className={"w-100"}
                              disabled={disabled}
                            >
                              <InputLabel htmlFor="outlined-Minutes">
                                Min Age
                              </InputLabel>
                              <Select
                                label="Min Age for Entry"
                                name="min_age"
                                id="min_age"
                                disabled={disabled}
                                className={`w-100 ${
                                  formik.errors.min_age &&
                                  formik.touched.min_age
                                    ? "enError outlined-Minutes"
                                    : "outlined-Minutes"
                                }`}
                                onChange={formik.handleChange}
                                value={formik.values.min_age}
                                onBlur={formik.handleBlur}
                                isInvalid={
                                  formik.errors.min_age &&
                                  formik.touched.min_age
                                }
                                // className="outlined-Minutes"
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                <MenuItem value={5}>age 5</MenuItem>
                                <MenuItem value={10}>age 10</MenuItem>
                                <MenuItem value={15}>age 15</MenuItem>
                                <MenuItem value={20}>age 18</MenuItem>
                              </Select>
                              {formik.errors.min_age &&
                              formik.touched.min_age ? (
                                <div className="pho_14_regular text-danger">
                                  {formik.errors.min_age}
                                </div>
                              ) : null}
                            </FormControl>
                          </div>
                        </div>
                      ) : null}
                      <hr />
                      <div className="row margin-between-toggler">
                        <div className="col-12 mb-4">
                          <h5
                            className="heading-seating-top"
                            style={{ fontSize: "0.85rem" }}
                          >
                            Do you provide services for the following?
                          </h5>
                        </div>
                        <div className="col-6 col-md-8">
                          <h5
                            className="left-toggle-top-text-head"
                            style={{ fontSize: "0.85rem" }}
                          >
                            Highchair
                          </h5>
                        </div>
                        <div className="col-4 col-md-4">
                          <ToggleButtonWithYesNo
                            disabled={disabled}
                            activeClass={state.casualGenralHighChair}
                            checkedBox={state.casualGenralHighChair}
                            onChange={genralSeatingScreenHandler("highChair")}
                          />
                        </div>
                      </div>
                      <div className="row margin-between-toggler">
                        <div className="col-6 col-md-8">
                          <h5
                            className="left-toggle-top-text-head"
                            style={{ fontSize: "0.85rem" }}
                          >
                            Handicap Access
                          </h5>
                        </div>
                        <div className="col-4 col-md-4">
                          <ToggleButtonWithYesNo
                            disabled={disabled}
                            activeClass={state.casualGenralHandicapAccess}
                            checkedBox={state.casualGenralHandicapAccess}
                            onChange={genralSeatingScreenHandler(
                              "handicapAccess"
                            )}
                          />
                        </div>
                      </div>
                      <br />
                      <div className="row margin-between-toggler">
                        <div className="col-6 col-md-8">
                          <h5
                            className="left-toggle-top-text-head"
                            style={{ fontSize: "0.85rem" }}
                          >
                            Room number on Seating Request?
                          </h5>
                          <div className="f12-700 opacity5">
                            (This may be relevant if you located inside a
                            hotel/resort)
                          </div>
                        </div>
                        <div className="col-4 col-md-4">
                          <ToggleButtonWithYesNo
                            activeClass={state.casualGenralRoomNumber}
                            checkedBox={state.casualGenralRoomNumber}
                            disabled={disabled}
                            onChange={genralSeatingScreenHandler("roomNumber")}
                          />
                        </div>
                      </div>
                      <hr />
                      <div className="row margin-between-toggler">
                        <div className="col-12 mb-4 mt-4">
                          <h4 className="heading-seating-top">Seating Other</h4>
                        </div>
                        <div className="col-6 col-md-8">
                          <h5
                            className="left-toggle-top-text-head"
                            style={{ fontSize: "0.85rem" }}
                          >
                            Do you use table/seat management?
                          </h5>
                          <div className="f12-700 opacity5">
                            If you use any software or option to manage your
                            tables
                          </div>
                        </div>
                        <div className="col-4 col-md-4">
                          <ToggleButtonWithYesNo
                            activeClass={state.casualGenralTableSeatManagement}
                            checkedBox={state.casualGenralTableSeatManagement}
                            onChange={genralSeatingScreenHandler("tableSeat")}
                            disabled={disabled}
                          />
                          {state.casualGenralTableSeatManagement ? (
                            <NewInputText
                              extraClass="mb-1 mt-4"
                              maxLength={35}
                              name="name_of_software"
                              inputType="text"
                              disabled={disabled}
                              onInput={maxLengthCheck}
                              onFocusOut={formik.handleBlur}
                              onChange={formik.handleChange}
                              value={formik.values.name_of_software}
                              labelText="Name of Software"
                              controlClass="name_of_software"
                            />
                          ) : null}
                        </div>
                      </div>
                      <br />
                      <div className="row margin-between-toggler">
                        <div className="col-6 col-md-8">
                          <h5
                            className="left-toggle-top-text-head"
                            style={{ fontSize: "0.85rem" }}
                          >
                            *Seating Capacity
                          </h5>
                          <div className="f12-700 opacity5">
                            (Total Seating capacity No. of People)
                          </div>
                        </div>
                        <div className="col-4 col-md-4">
                          <NewInputText
                            extraClass="mb-1"
                            maxLength={5}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            onInput={maxLengthCheck}
                            name="seat_capacity"
                            inputType="number"
                            onKeyDown={InputNumberFunc}
                            onFocusOut={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.seat_capacity}
                            labelText="Pax"
                            disabled={disabled}
                            controlClass="seat_capacity"
                          />
                          {formik.errors.seat_capacity &&
                          formik.touched.seat_capacity ? (
                            <div className="pho_14_regular text-danger">
                              {formik.errors.seat_capacity}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <br />
                      <div className="row margin-between-toggler">
                        <div className="col-6 col-md-8">
                          <h5
                            className="left-toggle-top-text-head"
                            style={{ fontSize: "0.85rem" }}
                          >
                            *Auto accept Pax Limit
                          </h5>
                          <div className="f12-700 opacity5">
                            (Request with pax below this will automatically be
                            accepted for seating, any number above this
                            threshold will go to pending for action)
                          </div>
                        </div>
                        <div className="col-4 col-md-4">
                          <NewInputText
                            extraClass="mb-1"
                            name="auto_pax"
                            maxLength={5}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            onInput={maxLengthCheck}
                            inputType="number"
                            onKeyDown={InputNumberFunc}
                            onFocusOut={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.auto_pax}
                            disabled={disabled}
                            labelText="Pax"
                            controlClass="auto_pax"
                          />
                          {formik.errors.auto_pax && formik.touched.auto_pax ? (
                            <div className="pho_14_regular text-danger">
                              {formik.errors.auto_pax}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <br />
                      <div className="row margin-between-toggler">
                        <div className="col-6 col-md-8">
                          <h5
                            className="left-toggle-top-text-head"
                            style={{ fontSize: "0.85rem" }}
                          >
                            *Table turn Around Time?
                          </h5>
                          <div className="f12-700 opacity5">
                            (How much time does it take to turn around tables
                            from seating to finish dining)
                          </div>
                        </div>
                        <div className="col-4 col-md-4">
                          <FormControl
                            variant="outlined"
                            className={"w-100"}
                            disabled={disabled}
                          >
                            <InputLabel htmlFor="outlined-Minutes">
                              Minutes
                            </InputLabel>
                            <Select
                              label="Minutes"
                              name="table_turn_around_time"
                              id="table_turn_around_time"
                              className={`w-100 ${
                                formik.errors.table_turn_around_time &&
                                formik.touched.table_turn_around_time
                                  ? "enError outlined-Minutes"
                                  : "outlined-Minutes"
                              }`}
                              disabled={disabled}
                              onChange={formik.handleChange}
                              value={formik.values.table_turn_around_time}
                              onBlur={formik.handleBlur}
                              isInvalid={
                                formik.errors.table_turn_around_time &&
                                formik.touched.table_turn_around_time
                              }
                              // className="outlined-Minutes"
                              IconComponent={KeyboardArrowDownIcon}
                            >
                              <MenuItem value={15}>15 Minutes</MenuItem>
                              <MenuItem value={30}>30 Minutes</MenuItem>
                              <MenuItem value={60}>90 Minutes</MenuItem>
                            </Select>
                            {formik.errors.table_turn_around_time &&
                            formik.touched.table_turn_around_time ? (
                              <div className="pho_14_regular text-danger">
                                {formik.errors.table_turn_around_time}
                              </div>
                            ) : null}
                          </FormControl>
                        </div>
                      </div>
                    </div>
                    <div className="onboarding-map-setup-screen-autodetect-button ">
                      <ReusableOnboardingButton
                        buttonTitle="Back Button"
                        buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                        buttonText="Back"
                        buttonType="button"
                        onClick={insideSeatingGenralBackClick}
                      />
                      <ReusableOnboardingButton
                        buttonTitle="Next Button"
                        disabled={disabled}
                        buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                        buttonText="Done"
                        buttonType="button"
                        onClick={() => onClickSave()}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
};

GenralSeatingScreen.propTypes = {
  auth: PropTypes.object.isRequired,
  admin_update_new_subscription_for_vendor: PropTypes.func.isRequired,
  subscription: PropTypes.object.isRequired,
  subscriptionData: PropTypes.object.isRequired,
  allSubscriptionsData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state?.auth,
  seating_area: state?.category && state?.category?.seating_area,
  subscription:
    state?.superAdminOnboarding &&
    state?.superAdminOnboarding?.onboard_subscription_details,
  subscriptionData:
    state?.superAdminOnboarding &&
    state?.superAdminOnboarding?.onboard_subscription_details &&
    state?.superAdminOnboarding?.onboard_subscription_details
      ?.casual_dining_status &&
    state?.superAdminOnboarding?.onboard_subscription_details
      ?.casual_dining_status?.seating &&
    state?.superAdminOnboarding?.onboard_subscription_details
      ?.casual_dining_status?.seating?.general_seating,
  allSubscriptionsData:
    state?.superAdminOnboarding &&
    state?.superAdminOnboarding?.onboard_subscription_details,
});

export default connect(mapStateToProps, {
  admin_update_new_subscription_for_vendor,
})(withRouter(GenralSeatingScreen));
